module.exports = __webpack_public_path__ + "img/skyboxes.e830664d.png";